
<template>
    <div class="confirm-delete-account-popup-component-container">
        <div class="confirm-delete-account-popup-component-wrapper scroll-bar">
            
            <div v-if="!showDeleteAccountMsg" class="popup-msg-container">
                <div class="popup-msg-title-container">
                    <p class="popup-msg-title-text">
                          {{ $t(`delete_account`) }}
                    </p>
                </div>

                <div class="popup-warning-container">
                    <div class="warning-img-container">
                        <img class="warning-img" src="../../assets/icons/alert.png" alt="Warning Image">
                    </div>
                    <div class="warning-text-container">
                        <p class="text-warning">{{ $t('if_you_delete_account') }}</p>
                        <div class="text-info-container">
                            <p class="text-info">{{ $t('no_longer_login_fit20_app') }}</p>
                        </div>
                    </div>
                </div>

                <div class="confirm-deleting-account-container">
                    <div class="confirm-deleting-account-text-container">
                        <p>{{ $t('confirm_delete_accout_typing') }} <span>{{ ($t('delete')).toUpperCase() }}</span></p>
                    </div>

                    <div class="confirm-deleting-account-input-container">
                        <input :class="errorTypingDelete ? 'error-typing-delete-text-input' : 'delete-text-input'" type="text" id="confirmationInput" :placeholder="$t('type_delete')">
                    </div>

                    <div v-if="errorTypingDelete" class="error-typing-delete-container">
                        <p class="error-typing-delete-text">
                            {{ $t('enter') }} <span>{{ ($t('delete')).toUpperCase() }}</span> {{ $t('to_confirm') }}
                        </p>
                    </div>
                </div>

                <div class="action-btns-container">
                    <div class="action-btn-container cancel-btn-container">
                        <div class="action-btn cancel-btn" @click="closeDeletingAccountPopupHandle" :class="{ 'disabled': loadingEventAction }">
                            <img src="../../assets/icons/cancel_icon.png" alt="">
                        </div>
                    </div>
                    <div class="action-btn-container confirm-btn-container">
                        <div v-if="!loadingEventAction" class="action-btn confirm-btn delete-btn"
                            @click="deleteAccountHandle"
                        >
                            <img src="../../assets/icons/check.png" alt="">
                        </div>
                        <div v-else class="spinner-container">
                            <div class="spinner">
                                <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="success-delete-account-msg-container">
                <div class="success-delete-account-msg-text-container">
                    <p>{{ $t('account_deleted_sccessfully') }}</p>
                </div>

                <div class="ok-btn-container">
                    <p class="ok-btn" @click="closeDeleteAccountMsgHandle">{{ $t('ok') }}</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'ConfirmDeleteAccountPopupPage',
    props: {
        showDeleteAccountMsg: Boolean,
        errorTypingDelete: Boolean,
        closeDeletingAccountPopupHandle: Function,
        loadingEventAction: Boolean,
        deleteAccount: Function,
    },
    methods: {
        closeDeleteAccountMsgHandle: function() {
            this.$store.logOut();
            this.$router.push("/start");
        },
        deleteAccountHandle: function() {
            const enteredInputText = document.getElementById('confirmationInput').value;

            this.deleteAccount(enteredInputText);
        }
    }
}
</script>

<style>
.confirm-delete-account-popup-component-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    /* align-items: center; */
    background: rgba(255, 255, 255, 0.75);
    z-index: 150;
    overflow: auto;
}

.confirm-delete-account-popup-component-container .confirm-delete-account-popup-component-wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    /* border-radius: 10px; */
    /* background: #ffffff; */
    overflow: auto;
}

.confirm-delete-account-popup-component-container .popup-msg-container {
    width: 85%;
    max-width: 500px;
    min-width: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 22px;
    background: #ffffff;
    margin: 20px 0;
    border: 2px solid #cb061d;
}

.confirm-delete-account-popup-component-container .popup-msg-title-container {
    width: 100%;
    border-radius: 20px 20px 0 0;
    overflow: hidden;
}

.confirm-delete-account-popup-component-container .popup-msg-title-text {
    color: #ffffff;
    font-size: 24px;
    font-family: 'VAG Rounded Std', sans-serif;
    /* font-weight: bold; */
    letter-spacing: 1px;
    padding: 6px 15px 5px;
    background: #cb061d;
}

.confirm-delete-account-popup-component-container .popup-warning-container {
    width: 100%;
    display: flex;
    padding: 10px 0 10px 20px;
    align-items: center;
}

[dir="rtl"] .confirm-delete-account-popup-component-container .popup-warning-container {
    padding: 10px 20px 10px 0;
}

.confirm-delete-account-popup-component-container .warning-img-container {
    width: 35px;
}

.confirm-delete-account-popup-component-container .warning-img {
    width: 100%;
}

.confirm-delete-account-popup-component-container .warning-text-container {
    flex: 1;
}

.confirm-delete-account-popup-component-container .warning-text-container .text-warning {
    font-size: 24px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
    line-height: 30px;
    font-weight: bold;
    padding: 5px 0 5px 15px;
}

[dir="rtl"] .confirm-delete-account-popup-component-container .warning-text-container .text-warning {
    padding: 5px 15px 5px 0;
}

.confirm-delete-account-popup-component-container .text-info-container {
    display: flex;
    align-items: center;
    padding-left: 25px;
}

[dir="rtl"] .confirm-delete-account-popup-component-container .text-info-container {
    display: flex;
    align-items: center;
    padding-right: 25px;
}

.confirm-delete-account-popup-component-container .warning-text-container .text-info {
    /* font-size: 17px; */
    font-family: 'VAG Rounded Std', sans-serif;
    color: #cb061d;
    /* padding-left: 20px; */
}

.confirm-delete-account-popup-component-container .warning-text-container .text-info::before {
    content: '*';
    align-items: center;
    padding-right: 5px;
    height: 100%;
}

[dir="rtl"] .confirm-delete-account-popup-component-container .warning-text-container .text-info::before {
    padding-right: 0;
    padding-left: 5px;
}

.confirm-delete-account-popup-component-container .confirm-deleting-account-container {
    width: 100%;
    padding: 15px 20px;
    /* display: flex;
    flex-direction: column; */
}

.confirm-delete-account-popup-component-container .confirm-deleting-account-text-container {
    width: 100%;
    padding: 10px 0 8px;
}

.confirm-delete-account-popup-component-container .confirm-deleting-account-text-container p {
    font-size: 18px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
}

.confirm-delete-account-popup-component-container .confirm-deleting-account-text-container span {
    color: #cb061d;
    font-weight: bold;
}

.confirm-delete-account-popup-component-container .confirm-deleting-account-input-container {
    width: 100%;
}

.confirm-delete-account-popup-component-container .confirm-deleting-account-input-container input {
    width: 100%;
    padding: 5px 8px;
    font-size: 18px;
    font-family: 'Open Sans Std', sans-serif;
    border-radius: 10px;
    /* color: #000000; */
    display: inline-block;
    outline: none;
    border: 1px solid #616365;
}

.confirm-delete-account-popup-component-container .delete-text-input {
    border: 1px solid #616365;
}

.confirm-delete-account-popup-component-container .error-typing-delete-text-input {
    border: 1px solid #cb061d;
}

.confirm-delete-account-popup-component-container input::placeholder {
  color: #a0a1a3;
}

.confirm-delete-account-popup-component-container .delete-text-input:focus {
  outline: 1px solid #616365;
  border: 1px solid #616365;
}

.confirm-delete-account-popup-component-container .error-typing-delete-text-input:focus {
  outline: 1px solid #cb061d;
  border: 1px solid #cb061d;
}

.confirm-delete-account-popup-component-container .error-typing-delete-container {
    padding: 5px;
}

.confirm-delete-account-popup-component-container .error-typing-delete-text {
    font-family: 'Open Sans Std', sans-serif;
    font-size: 14px;
    color: #cb061d;
}

.confirm-delete-account-popup-component-container .error-typing-delete-text span {
    font-weight: bold;
}

.confirm-delete-account-popup-component-container .action-btns-container {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 20px 0;
}

.confirm-delete-account-popup-component-container .action-btn-container {
    height: 39px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    padding: 1px 30px;
    overflow: hidden;
    cursor: pointer;
}

.confirm-delete-account-popup-component-container .cancel-btn-container {
    background: #a0a1a3;
}

.confirm-delete-account-popup-component-container .confirm-btn-container {
    background: #cb061d;
}

.confirm-delete-account-popup-component-container .action-btn {
    /* width: 35%; */
    width: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin: 5px 0;
    /* border: 1px solid; */
}

.confirm-delete-account-popup-component-container .cancel-btn img {
    width: 70%;
}

.confirm-delete-account-popup-component-container .delete-btn img {
    width: 90%;
}

.confirm-delete-account-popup-component-container .disabled {
  pointer-events: none;
  cursor: not-allowed;
}

.confirm-delete-account-popup-component-container .spinner-container {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.confirm-delete-account-popup-component-container .spinner {
    width: 20% !important;
    max-width: 100px !important;
}

.confirm-delete-account-popup-component-container .success-delete-account-msg-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
}

.confirm-delete-account-popup-component-container .success-delete-account-msg-text-container {
    padding: 15px 10px 25px;
}

.confirm-delete-account-popup-component-container .success-delete-account-msg-text-container p {
    font-size: 22px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    /* text-align: center; */
    line-height: 35px;
    font-weight: bold;
}

.confirm-delete-account-popup-component-container .ok-btn-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.confirm-delete-account-popup-component-container .ok-btn {
    width: 35%;
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 8px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

@media (max-width: 425px) {

    .confirm-delete-account-popup-component-container .popup-msg-title-text {
        /* font-size: 20px; */
        font-size: calc(12px + 2vw);
    }

    .confirm-delete-account-popup-component-container .warning-img-container {
        width: 25px;
    }

    .confirm-delete-account-popup-component-container .warning-text-container .text-warning {
        font-size: calc(12px + 2vw);
    }

    .confirm-delete-account-popup-component-container .warning-text-container .text-info {
        /* font-size: 12px; */
        font-size: calc(10px + 1.1vw);
    }

    .confirm-delete-account-popup-component-container .confirm-deleting-account-text-container p {
        /* font-size: 14px; */
        font-size: calc(10px + 1vw);
        letter-spacing: 1px;
    }

    .confirm-delete-account-popup-component-container .confirm-deleting-account-input-container input {
        font-size: 14px;
        padding: 5px;
    }

    .confirm-delete-account-popup-component-container .error-typing-delete-text {
        font-size: 12px;
    }

    .confirm-delete-account-popup-component-container .action-btn {
        font-size: 16px;
        padding: 10px 0px;
    }
}

@media (max-width: 375px) {

    .confirm-delete-account-popup-component-container .popup-msg-container {
        width: 95%;
    }

    .confirm-delete-account-popup-component-container .warning-img-container {
        margin-right: 5px;
    }

    .confirm-delete-account-popup-component-container .warning-text-container {
        flex: none;
    }

    .confirm-delete-account-popup-component-container .warning-text-container .text-warning {
        font-size: 18px;
        padding: 0;
    }

    .confirm-delete-account-popup-component-container .text-info-container {
        padding-left: 5px;
    }
    
    .confirm-delete-account-popup-component-container .confirm-deleting-account-text-container p {
        /* font-size: 11px; */
        font-size: calc(10px + 0.8vw);
    }

    .confirm-delete-account-popup-component-container .warning-text-container .text-info {
        font-size: 11px;
        font-size: calc(10px + 1vw);
    }

    .confirm-delete-account-popup-component-container .action-btn-container {
        width: 45%;
    }

    .confirm-delete-account-popup-component-container .action-btn {
        font-size: 14px;
        padding: 10px 0px;
    }
}
</style>

